// extracted by mini-css-extract-plugin
export var actions = "_2q-0";
export var actionsContainer = "_2q-7";
export var border = "_2q-1";
export var childFullHeight = "_2q-f";
export var collapse = "_2q-2";
export var content = "_2q-a";
export var contentChild = "_2q-e";
export var fullscreen = "_2q-c";
export var hasLeftRadius = "_2q-k";
export var headerContainer = "_2q-3";
export var headerRow = "_2q-5";
export var hidePadding = "_2q-b";
export var navCollapsedGap = "_2q-l";
export var noScrollX = "_2q-m";
export var noScrollY = "_2q-n";
export var noTopPadding = "_2q-i";
export var optOutTopPadding = "_2q-d";
export var pageMain = "_2q-j";
export var pageOuter = "_2q-g";
export var pagePadding = "_2q-8";
export var pageScroll = "_2q-9";
export var profile = "_2q-o";
export var profileContainer = "_2q-p";
export var profileImage = "_2q-q";
export var profileMain = "_2q-r";
export var profileSubtitle = "_2q-t";
export var profileTitle = "_2q-s";
export var showLeftPadding = "_2q-h";
export var tabsPortalSlot = "_2q-6";
export var tabsWrapper = "_2q-4";
export var title = "_2q-u";